export default async function importOrReload(
  dynamicImportFn: () => Promise<any>,
) {
  try {
    return await dynamicImportFn();
  } catch (e) {
    console.error('Error importing module, reloading...', e);
    window.location.reload();
  }
}
